// extracted by mini-css-extract-plugin
export default {"item":"Header_item__OOEY7","icon":"Header_icon__a8FkJ","labelIcon":"Header_labelIcon__joHIt","newBadge":"Header_newBadge__ZkMkT","newBadgeContent":"Header_newBadgeContent__y2Kbn"};